import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesReportesAdmin() {
  const { user } = useContext(AuthContext);
  const SECCIONES = [
    { section: "Clientes", items: [
      { label: "Calificadora Clientes", icon: "fas fa-exclamation-circle", color: "#f59e0b", href: "/CalificadoraClientes", desc: "Calificacion de clientes", enabled: !!user.edoCtaClientes },
    ]},
    { section: "Cobranza", items: [
      { label: "Abonos", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ListadoAbonos", desc: "Listado de abonos", enabled: !!user.abonos },
      { label: "Antiguedad Saldos Vencido", icon: "fas fa-dollar-sign", color: "#ef4444", href: "/AntiguedadSaldosVencido", desc: "Saldos vencidos", enabled: !!user.abonos },
      { label: "Antiguedad Saldos Pend", icon: "fas fa-dollar-sign", color: "#f59e0b", href: "/AntiguedadSaldosPorCobrar", desc: "Saldos pendientes", enabled: !!user.abonos },
    ]},
  ];
  return (
    <MenuBotones titulo="Reportes Admin" descripcion="Reportes administrativos" icono="fas fa-dollar-sign" color="#10b981" secciones={SECCIONES} />
  );
}

export default BotonesReportesAdmin;
